import { render, staticRenderFns } from "./itemB.vue?vue&type=template&id=c1b5379c&scoped=true&"
import script from "./itemB.vue?vue&type=script&lang=js&"
export * from "./itemB.vue?vue&type=script&lang=js&"
import style0 from "./itemB.vue?vue&type=style&index=0&id=c1b5379c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b5379c",
  null
  
)

export default component.exports